import { Form, Input } from "antd";

export const documentSeries = [
  {
    label: "Nghiệp vụ khai thác",
    value: "exploit",
  },
  {
    label: "Nghiệp vụ quản lý chất lượng",
    value: "quanlity",
  },
  {
    label: "Nghiệp vụ văn phòng",
    value: "office",
  },
  {
    label: "Đối tượng người dùng",
    value: "users",
  },
  {
    label: "Loại văn bản",
    value: "docType",
  },
  {
    label: "Tài liệu SQMS",
    value: "sqms",
  },
];

export const DocumentTagsFormItem = () => {
  return (
    <>
      <Form.Item
        label="Danh mục chủ đề"
        name="eTagType"
        colon={false}
        rules={[{ required: true, message: "Vui lòng nhập danh mục" }]}
      >
        <Input autoFocus />
      </Form.Item>
      <Form.Item
        label="Tên chủ đề"
        name="Title"
        colon={false}
        rules={[{ required: true, message: "Vui lòng nhập tên chủ đề" }]}
      >
        <Input autoFocus />
      </Form.Item>
    </>
  );
};
